<template>
  <a target="_blank" :href="viewOnSocialUrl" class="selection-card">
    <div :class="getCardClass">
      <div class="row">
        <div class="col-10">
          <div class="row">
            <div class="col-3 avatar-size">
              <img class="avatar avatar-edge" v-if="profileImageUrl !== ''" :src="profileImageUrl"/>
            </div>
            <div class="col-9 postAuthor">
              <a target="_blank" :href="userPostUrl">
              <span class="postAuthor-decoratedName">
                <span class="postAuthor-name identity-name" :title="userName">
                  {{userName}}
                </span>
                <span class="postAuthor-verifiedBadge">
                  <div v-bind:class="[{'u-hiddenVisually': !verifiedUser}, iconStyle]"
                       aria-label="Verified Account"
                       title="Verified Account"
                       role="img"></div>
                </span>
              </span>
                <span class="postAuthor-screenName identity-screenName" :title="atScreenName" dir="ltr">
                {{atScreenName}}
              </span>
              </a>
            </div>
          </div>
        </div>
        <div class="col-2 post-brand">
          <template v-if="isTwitter">
            <a target="_blank" :href="viewOnSocialUrl">
          <span class="followButton">
            <div class="icon icon-twitter " aria-label="View on Social" title="View on Social"
                 role="presentation"></div>
          </span>
            </a>
          </template>

          <template v-else-if="isInstagram">
            <a target="_blank" :href="externalUrl">
          <span class="followButton">
            <div class="icon icon-instagram" aria-label="View on Social" title="View on Social"
                 role="presentation"></div>
          </span>
            </a>
          </template>

          <template v-else-if="isFacebook">
            <a target="_blank" :href="externalUrl">
          <span class="followButton">
            <div class="icon icon-facebook" aria-label="View on Social" title="View on Social"
                 role="presentation"></div>
          </span>
            </a>
          </template>

        </div>
      </div>
      <div class="post-body">
        <p class="post-text" dir="ltr" v-html="postText"></p>
        <div class="post-metadata dateline">

          <a class="u-linkBlend u-url customisable-highlight long-permalink" data-datetime="2017-04-06T15:24:15+0000"
             data-scribe="element:full_timestamp"
             data-url-ref-attrs-injected="true">
            <p class="dt-updated post-alert" title="Time posted">
              {{ createdAtMoment | moment('h:mm A - MMMM D, YYYY') }}
            </p>
          </a>
        </div>
        <div class="post-card">
          <img class="post-image" :src="imageUrl"/>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
    export default {
      name: 'SocialCard',
      data () {
        return {
          iconStyle: 'icon icon-verified',
          profileImageUrl: '',
          userScreenName: '',
          userName: '',
          verifiedUser: false,
          postId: '',
          postText: '',
          createdAt: '',
          imageUrl: '',
          externalUrl: '',
          type: '',
          isSmallWindow: false
        }
      },
      props: {
        postContent: {
          type: Object,
          default: {}
        }
      },
      computed: {
        userPostUrl () {
          if (this.type === 'Instagram') {
            return 'https://www.instagram.com/' + this.userScreenName
          } else {
            return 'https://www.twitter.com/' + this.userScreenName
          }
        },
        atScreenName () {
          return this.userScreenName ? '@' + this.userScreenName : '(utente non riconosciuto)'
        },
        viewOnSocialUrl () {
          if (this.type === 'Instagram') {
            return this.externalUrl
          }
          return this.userPostUrl + '/status/' + this.postId
        },
        createdAtMoment () {
          if (this.createdAt) {
            let s = this.$moment(this.createdAt)
            if (s.isValid()) {
              return s
            }
          }
          return this.$moment()
        },
        isTwitter () {
          return this.type === 'Twitter'
        },
        isInstagram () {
          return this.type === 'Instagram'
        },
        isFacebook () {
          return this.type === 'Facebook'
        },
        getCardClass () {
          return this.isSmallWindow ? 'f-socialCard-mobile embeddedPost-post' : 'f-socialCard embeddedPost-post'
        }
      },
      methods: {
        initializeFields () {
          if (this.postContent) {
            this.userScreenName = this.postContent.user.screenName
            this.userName = this.postContent.user.name
            this.verifiedUser = this.postContent.user.verified
            this.postId = this.postContent.id_str
            this.postText = this.postContent && this.postContent.text ? this.postContent.text.replace(/#(\w+)/g, '<a target="_blank" href="https://twitter.com/search?q=%23$1&src=typd" style="color: #1c94e0;">#$1</a>') : ''
            this.createdAt = this.postContent.createdAt
            this.imageUrl = this.postContent.imageUrl
            this.externalUrl = this.postContent.externalUrl
            this.type = this.postContent.type
          }
        },
        checkWindowSize () {
          if ((!this.isSmallWindow) && window.innerWidth < 1051) {
            this.isSmallWindow = true
          } else if (this.isSmallWindow && window.innerWidth > 1051) {
            this.isSmallWindow = false
          }
        },
        checkProfileImage (clb) {
          let self = this
          if (this.postContent.user.profileImageUrl) {
            this.$http.get(this.postContent.user.profileImageUrl).then((response) => {
              if (response.status === 200) {
                self.profileImageUrl = self.postContent.user.profileImageUrl
                clb()
              }
            }).catch(function () {
              self.$emit('update-image', self.postContent.user.screenName)
              self.profileImageUrl = require('../../assets/placeholder/profile_placeholder.png')
              clb()
            })
          } else {
            self.$emit('update-image', self.postContent.user.screenName)
            self.profileImageUrl = require('../../assets/placeholder/profile_placeholder.png')
            clb()
          }
        }
      },
      created () {
        this.checkProfileImage(() => this.initializeFields())
        this.checkWindowSize()
        window.addEventListener('resize', () => this.checkWindowSize())
      }
    }
</script>

<style scoped>

  .f-socialCard {
    border: 1px solid #e1e8ed;
    overflow: hidden;
    cursor: pointer;
    background-color: #fff;
    border-radius: 4px;
    max-width: 350px;
    margin: 2%;
  }

  .f-socialCard-mobile {
    border: 1px solid #e1e8ed;
    overflow: hidden;
    cursor: pointer;
    background-color: #fff;
    border-radius: 4px;
    margin: 2%;
  }

  .f-socialCard:hover {
    box-shadow: 1px 1px 5px grey;
  }

  img {
    border: 0;
  }


  a {
    color: #1c2022 !important;
    text-decoration: none;
  }

  a:hover {
    text-decoration: none;
    outline: 0;
  }

  .embeddedPost-post {
    padding: 20px 20px 20px 20px;
  }

  .avatar-size {
    padding-right: 3%;
  }

  .avatar {
    max-width: 100%;
    max-height: 100%;
  }

  .avatar-edge {
    border-radius: 50%;
  }

  .postAuthor-decoratedName {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    min-width: 0;
  }

  .postAuthor {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -moz-box-orient: vertical;
    -moz-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    overflow: hidden;
  }

  .postAuthor-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right: 4px;
  }

  .postAuthor-name:hover {
    color: #c41c21;
  }

  .identity-name {
    font-weight: 700;
  }

  .postAuthor-verifiedBadge {
    position: static;
    -webkit-box-flex: 0;
    -webkit-flex: none;
    -moz-box-flex: 0;
    -ms-flex: none;
    flex: none;
    padding-right: 4px;
  }

  .icon-verified {
    width: 1.11111em;
    background-image: url("data:image/svg+xml;utf8;base64,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");
  }

  .icon {
    display: inline-block;
    height: 1.25em;
    background-repeat: no-repeat;
    background-size: contain;
    vertical-align: text-bottom;
  }

  .u-hiddenVisually {
    position: absolute !important;
    overflow: hidden !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    border: 0 !important;
    clip: rect(1px, 1px, 1px, 1px) !important;
  }

  b, i {
    font-weight: 400;
    font-style: normal;
  }

  .postAuthor-screenName {
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    -webkit-flex-shrink: 1;
    -ms-flex-negative: 1;
    flex-shrink: 1;
    float: left;
  }

  .identity-screenName {
    color: #697882 !important;
  }

  .post-brand {
    margin-left: auto;
  }

  .icon-twitter {
    width: 1.25em;
    background-image: url("data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTguMS4xLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDYxMiA2MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDYxMiA2MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iNjRweCIgaGVpZ2h0PSI2NHB4Ij4KPGc+Cgk8Zz4KCQk8cGF0aCBkPSJNNjEyLDExNi4yNThjLTIyLjUyNSw5Ljk4MS00Ni42OTQsMTYuNzUtNzIuMDg4LDE5Ljc3MmMyNS45MjktMTUuNTI3LDQ1Ljc3Ny00MC4xNTUsNTUuMTg0LTY5LjQxMSAgICBjLTI0LjMyMiwxNC4zNzktNTEuMTY5LDI0LjgyLTc5Ljc3NSwzMC40OGMtMjIuOTA3LTI0LjQzNy01NS40OS0zOS42NTgtOTEuNjMtMzkuNjU4Yy02OS4zMzQsMC0xMjUuNTUxLDU2LjIxNy0xMjUuNTUxLDEyNS41MTMgICAgYzAsOS44MjgsMS4xMDksMTkuNDI3LDMuMjUxLDI4LjYwNkMxOTcuMDY1LDIwNi4zMiwxMDQuNTU2LDE1Ni4zMzcsNDIuNjQxLDgwLjM4NmMtMTAuODIzLDE4LjUxLTE2Ljk4LDQwLjA3OC0xNi45OCw2My4xMDEgICAgYzAsNDMuNTU5LDIyLjE4MSw4MS45OTMsNTUuODM1LDEwNC40NzljLTIwLjU3NS0wLjY4OC0zOS45MjYtNi4zNDgtNTYuODY3LTE1Ljc1NnYxLjU2OGMwLDYwLjgwNiw0My4yOTEsMTExLjU1NCwxMDAuNjkzLDEyMy4xMDQgICAgYy0xMC41MTcsMi44My0yMS42MDcsNC4zOTgtMzMuMDgsNC4zOThjLTguMTA3LDAtMTUuOTQ3LTAuODAzLTIzLjYzNC0yLjMzM2MxNS45ODUsNDkuOTA3LDYyLjMzNiw4Ni4xOTksMTE3LjI1Myw4Ny4xOTQgICAgYy00Mi45NDcsMzMuNjU0LTk3LjA5OSw1My42NTUtMTU1LjkxNiw1My42NTVjLTEwLjEzNCwwLTIwLjExNi0wLjYxMi0yOS45NDQtMS43MjFjNTUuNTY3LDM1LjY4MSwxMjEuNTM2LDU2LjQ4NSwxOTIuNDM4LDU2LjQ4NSAgICBjMjMwLjk0OCwwLDM1Ny4xODgtMTkxLjI5MSwzNTcuMTg4LTM1Ny4xODhsLTAuNDIxLTE2LjI1M0M1NzMuODcyLDE2My41MjYsNTk1LjIxMSwxNDEuNDIyLDYxMiwxMTYuMjU4eiIgZmlsbD0iIzAwNkRGMCIvPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=")
  }

  .icon-instagram {
    width: 1.25em;
    background-image: url("data:image/svg+xml;utf8;base64,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")
  }

  .icon-facebook {
    width: 1.25em;
    background-image: url("data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA0MDguNzg4IDQwOC43ODgiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQwOC43ODggNDA4Ljc4ODsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCI+CjxwYXRoIHN0eWxlPSJmaWxsOiM0NzU5OTM7IiBkPSJNMzUzLjcwMSwwSDU1LjA4N0MyNC42NjUsMCwwLjAwMiwyNC42NjIsMC4wMDIsNTUuMDg1djI5OC42MTZjMCwzMC40MjMsMjQuNjYyLDU1LjA4NSw1NS4wODUsNTUuMDg1ICBoMTQ3LjI3NWwwLjI1MS0xNDYuMDc4aC0zNy45NTFjLTQuOTMyLDAtOC45MzUtMy45ODgtOC45NTQtOC45MmwtMC4xODItNDcuMDg3Yy0wLjAxOS00Ljk1OSwzLjk5Ni04Ljk4OSw4Ljk1NS04Ljk4OWgzNy44ODIgIHYtNDUuNDk4YzAtNTIuOCwzMi4yNDctODEuNTUsNzkuMzQ4LTgxLjU1aDM4LjY1YzQuOTQ1LDAsOC45NTUsNC4wMDksOC45NTUsOC45NTV2MzkuNzA0YzAsNC45NDQtNC4wMDcsOC45NTItOC45NSw4Ljk1NSAgbC0yMy43MTksMC4wMTFjLTI1LjYxNSwwLTMwLjU3NSwxMi4xNzItMzAuNTc1LDMwLjAzNXYzOS4zODloNTYuMjg1YzUuMzYzLDAsOS41MjQsNC42ODMsOC44OTIsMTAuMDA5bC01LjU4MSw0Ny4wODcgIGMtMC41MzQsNC41MDYtNC4zNTUsNy45MDEtOC44OTIsNy45MDFoLTUwLjQ1M2wtMC4yNTEsMTQ2LjA3OGg4Ny42MzFjMzAuNDIyLDAsNTUuMDg0LTI0LjY2Miw1NS4wODQtNTUuMDg0VjU1LjA4NSAgQzQwOC43ODYsMjQuNjYyLDM4NC4xMjQsMCwzNTMuNzAxLDB6Ii8+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=")
  }

  .followButton {
    display: inline-block;
  }

  .post-body {
    margin-top: 14px;
  }

  .post-text[dir=ltr] {
    text-align: left;
    direction: ltr;
    margin: 0;

  }

  .post-text {
    white-space: pre-wrap;
    cursor: pointer;
    word-wrap: break-word;
  }

  .post-text + .post-metadata {
    float: left;
    margin-top: 3.2px;
  }

  .post-alert, .post-metadata {
    font-size: 14px;
    color: #697882;
  }

  .u-linkBlend:not(:focus):not(:hover):not(:active) {
    font-weight: inherit;
    color: inherit;
    text-decoration: inherit;
  }

  .post-alert, .post-metadata {
    font-size: 12px;
    color: #697882;
  }

  .post-card {
    margin-top: 10px;
    font-size: 14px;
  }

  .post-image {
    max-width: 100%;
    border-radius: 5px;
  }

  .post-text > a :hover {
    text-decoration: underline;
  }

</style>




// WEBPACK FOOTER //
// src/components/utilComponents/SocialCard.vue